/* eslint-disable max-len */
import React, { useState } from 'react';
import DropdownIcon from '../../svgs/DropdownIcon';
import CheckboxNew from '../CheckboxNew';
import Styles from './PermissionDropdown.module.scss';

interface IPermissionDropdown{
  data:any;
  handleUpdateCheckStatus:any;
}
const PermissionDropdown = ({ data, handleUpdateCheckStatus }:IPermissionDropdown) => {
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [toggleDropdownId, setToggleDropdownId] = useState(null);

  return (
    <div className={Styles.wrapper}>
      <div
        className={Styles.wrapper__titleAndIcon}
        onClick={() => {
          setToggleDropdown(!toggleDropdown);
          setToggleDropdownId(data?.group);
        }}
      >
        <div className={toggleDropdown && toggleDropdownId === data?.group ? Styles.wrapper__activeTitle : Styles.wrapper__title}>{data?.group || ''}</div>
        <div className={toggleDropdown && toggleDropdownId === data?.group ? Styles.wrapper__titleIconUp : Styles.wrapper__titleIconDown}>
          <DropdownIcon color="rgba(0, 0, 0, 1)" />
        </div>
      </div>
      {
        toggleDropdown && toggleDropdownId === data?.group && (
        <div className={Styles.wrapper__DetailsList}>
          {
            data?.permissions?.map((list:any) => (
              <div className={Styles.wrapper__DetailsTitleAndCheck}>
                <CheckboxNew isLeftContent width="100%" onClick={() => handleUpdateCheckStatus(list?.id, data?.group)} name="" value={list?.hasPermission} iconColor="white" backgroundColor={list?.hasPermission ? 'rgba(18, 18, 18, 1)' : 'white'} height="fit-content">
                  <span className={Styles.wrapper__checkContent}>
                    {' '}
                    {list?.name?.split('-')?.join(' ')}
                  </span>

                </CheckboxNew>
              </div>
            ))
          }

        </div>
        )
      }

    </div>
  );
};

export default PermissionDropdown;
